import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { ContaCaixaConfiguracao } from '../models/conta-caixa-configuracao';
import { ConfiguracaoCaixaApiService } from '../services/configuracao-caixa-api.service';

@Injectable()
export class ContasArquivadasResolver implements Resolve<ContaCaixaConfiguracao[]> {

  constructor(
    private contasArquivadasApiService: ConfiguracaoCaixaApiService,
  ) { }

  resolve(): Observable<ContaCaixaConfiguracao[]> {
    return this.contasArquivadasApiService.getContasArquivadas();
  }
}
